export default __webpack_public_path__ + "static/media/staples-Button.cac24807.png";